import { render } from "./ImageComp.vue?vue&type=template&id=59035750&scoped=true"
import script from "./ImageComp.vue?vue&type=script&lang=js"
export * from "./ImageComp.vue?vue&type=script&lang=js"

import "./ImageComp.vue?vue&type=style&index=0&id=59035750&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59035750"]])

export default __exports__